const sleepModeArray = [
    { time: null, second: null, wording: "endOfEpisode" },
    { time: 10, second: 600, wording: "minutes" },
    { time: 20, second: 1200, wording: "minutes" },
    { time: 30, second: 1800, wording: "minutes" },
    { time: 45, second: 2700, wording: "minutes" },
    { time: 1, second: 3600, wording: "oneHour" },
  ]

  export default sleepModeArray